import React from "react";
import { auth } from "@/lib/admin/api";
import { PageHead } from "@/pages/admin/Layout";

const PAGES = [
  { id: "home", label: "Home", path: "/2high/v11/index.html" },
  { id: "menu", label: "Menu", path: "/2high/v11/menu.html" },
];

export default function VisualEditor() {
  const [pageId, setPageId] = React.useState("home");
  const [fullscreen, setFullscreen] = React.useState(false);
  const [reloadKey, setReloadKey] = React.useState(0);
  const iframeRef = React.useRef(null);

  const page = PAGES.find((p) => p.id === pageId) || PAGES[0];
  const src = `${page.path}?edit=1&t=${reloadKey}`;

  React.useEffect(() => {
    function handler(e) {
      if (e.data === "2high-editor-need-token" && iframeRef.current) {
        iframeRef.current.contentWindow.postMessage({ type: "2high-token", token: auth.token }, "*");
      }
    }
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 bg-[#04060f]" data-testid="visual-fullscreen">
        <iframe
          ref={iframeRef}
          src={src}
          title="2High Visual Editor"
          className="w-full h-full border-0"
          data-testid="visual-iframe"
        />
        <button
          onClick={() => setFullscreen(false)}
          data-testid="visual-exit-fs"
          className="fixed top-3 right-3 z-50 px-4 py-2 rounded-full bg-[#c9b88a] text-[#04060f] text-[10px] tracking-[.28em] uppercase font-bold shadow-lg hover:bg-white transition"
        >Exit Fullscreen</button>
      </div>
    );
  }

  return (
    <div data-testid="visual-editor-page">
      <PageHead
        eye="VISUAL EDITOR"
        title="Edit the site visually"
        sub="Secondary tool. For daily operations use Products / Homepage / Proof. This is for quick live text fixes."
        right={
          <div className="flex gap-2 flex-wrap">
            {PAGES.map((p) => (
              <button
                key={p.id}
                onClick={() => { setPageId(p.id); setReloadKey((k) => k + 1); }}
                data-testid={`visual-tab-${p.id}`}
                className={`px-3.5 py-1.5 rounded-full text-[10px] tracking-[.28em] uppercase border transition ${
                  pageId === p.id
                    ? "bg-[#c9b88a] text-[#04060f] border-[#c9b88a]"
                    : "bg-white/5 text-[#e8e4d8] border-[#c9b88a]/25 hover:bg-white/10"
                }`}
              >{p.label}</button>
            ))}
            <button
              onClick={() => setReloadKey((k) => k + 1)}
              data-testid="visual-reload"
              className="px-3.5 py-1.5 rounded-full text-[10px] tracking-[.28em] uppercase border border-[#c9b88a]/25 text-[#e8e4d8] bg-white/5 hover:bg-white/10"
            >↻ Reload</button>
            <button
              onClick={() => setFullscreen(true)}
              data-testid="visual-fullscreen-btn"
              className="px-3.5 py-1.5 rounded-full text-[10px] tracking-[.28em] uppercase bg-[#c9b88a] text-[#04060f] font-bold hover:bg-white"
            >⛶ Fullscreen</button>
          </div>
        }
      />

      <div className="rounded-2xl border border-[#c9b88a]/25 overflow-hidden bg-[#04060f] shadow-2xl" style={{ height: "calc(100vh - 220px)", minHeight: 560 }}>
        <iframe
          ref={iframeRef}
          src={src}
          title="2High Visual Editor"
          className="w-full h-full border-0"
          data-testid="visual-iframe"
        />
      </div>
    </div>
  );
}
